import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'
import {WithTheme} from "@yosmanyga/theme";

type ProgressProps = {
}

const Progress = ({
    ...props
}: ProgressProps) => {
    const {Progress: BaseProgress} = usePrimitives()

    if (!BaseProgress) {
        throw new NonExistentPrimitiveError('Progress')
    }

    return <BaseProgress
        {...props}
    />
}

const ProgressWithTheme = (props: ProgressProps & UnnormalizedStyleProps) => <WithTheme
    {...props}
    identifier='progress'
    Component={Progress}
/>

export default ProgressWithTheme
